export type TemplateValues = Record<string, string>

const TOKEN_PATTERN = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g

const interpolateTemplate = (
  template: string,
  values: TemplateValues
): string =>
  template.replace(TOKEN_PATTERN, (fullMatch, key: string) =>
    Object.hasOwn(values, key) ? values[key] : fullMatch
  )

export default interpolateTemplate
